import { sidebarOpenTabAtom, SidebarTab } from '@/atoms/persistedPreferencesAtoms';
import { IS_SIDEBAR_PANEL_ENABLED } from '@/components/constants/flags';
import { useSettingsModal } from '@/features/settings/hooks/useSettingsModal';
import { useIntegrationsMarketplaceVisibilityGate } from '@/features/settings/integrations/integrations-marketplace-visibility-gate';
import { useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';
import { cn } from '@/lib/cn';
import { Button } from '@heidi/design-system/button';
import {
  TypographyCaption,
  TypographyCaptionBold,
} from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { useAtomValue } from 'jotai';
import { PlugZap } from 'lucide-react';
import { EHRSessions } from './side-nav-list/integration/ehr-sessions-list/side-nav-ehr-sessions-list';

export default function SessionBarUpcomingTab() {
  const { open: openSettingsModal } = useSettingsModal();
  const { t } = useTranslations();
  const marketplaceVisibility = useIntegrationsMarketplaceVisibilityGate();
  const showMarketplaceCta = marketplaceVisibility === 'visible';

  const { integrationEhrProvider, canSyncSchedule } = useIntegrationEhrInfo();

  const sidebarOpenTab = useAtomValue(sidebarOpenTabAtom);
  // When the sidebar panel is enabled, it manages its own visibility —
  // the Redux sidebarOpenTab is never set, so always treat the list as open.
  const isSidebarSessionListOpen =
    IS_SIDEBAR_PANEL_ENABLED() || sidebarOpenTab === SidebarTab.SESSION_LIST;

  // Hide schedule tab if there is only one EHR provider and the provider is not supported
  // We assume that multiple onboarding sessions supports schedule sync
  if (integrationEhrProvider && canSyncSchedule) {
    return <EHRSessions />;
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-1 pt-8 transition-all',
        isSidebarSessionListOpen
          ? 'translate-y-0 opacity-100 duration-1000'
          : '-translate-y-5 opacity-0'
      )}
    >
      <TypographyCaptionBold>{t('sessions.showUpcomingSessions')}</TypographyCaptionBold>
      {showMarketplaceCta ? (
        <>
          <TypographyCaption className="overflow-hidden text-center text-text-secondary">
            {t('sessions.integrateWithPractice')}
          </TypographyCaption>

          <Button
            size="lg"
            disableAutomaticSvgSizing
            className="mt-2 flex h-fit w-auto gap-1.5 px-2.5 py-2"
            type="button"
            onClick={() => {
              openSettingsModal('/settings/integrations', 'sidebar');
            }}
            data-testid="setup-integration-button"
          >
            <PlugZap size={16} />
            <TypographyCaptionBold>
              {t('integrations.setupIntegration')}
            </TypographyCaptionBold>
          </Button>
        </>
      ) : null}
    </div>
  );
}
